:host {
  display: block;

  av-button {
    --av-container-round-lg-padding: var(--av-font-size);
  }

  av-spinner {
    transform: translate(-50%, -50%) scale(0.4);
    position: absolute;
    top: 50%;
    left: 50%;
  }

  av-asset {
    height: 100%;
    width: 100%;
  }

  .av-launcher {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    width: $container-width;
  }
  .av-launcher-disabled {
    av-asset {
      opacity: 0.5;
    }
  }

  .av-launcher-open {
    .av-launcher-item {
      visibility: visible;
      label {
        display: block;
        opacity: 0;
        text-shadow: 0 0 2px transparentize($color: white, $amount: 0.5);
        width: 100%;
        visibility: visible;
        transform: scale(1);
        white-space: nowrap;
      }
    }

    &.av-launcher-bottom {
      .av-launcher-item {
        bottom: 0;
        &:nth-child(1) {
          transform: translateY(calc(-1 * $container-height));
        }
        &:nth-child(2) {
          transform: translateY(calc(-2 * $container-height));
        }
        &:nth-child(3) {
          transform: translateY(calc(-3 * $container-height));
        }
        &:nth-child(4) {
          transform: translateY(calc(-4 * $container-height));
        }
        &:nth-child(5) {
          transform: translateY(calc(-5 * $container-height));
        }
        &:nth-child(6) {
          transform: translateY(calc(-6 * $container-height));
        }
      }
    }

    &.av-launcher-top {
      .av-launcher-item {
        top: 0;
        &:nth-child(1) {
          transform: translateY($container-height);
        }
        &:nth-child(2) {
          transform: translateY(calc(2 * $container-height));
        }
        &:nth-child(3) {
          transform: translateY(calc(3 * $container-height));
        }
        &:nth-child(4) {
          transform: translateY(calc(4 * $container-height));
        }
        &:nth-child(5) {
          transform: translateY(calc(5 * $container-height));
        }
        &:nth-child(6) {
          transform: translateY(calc(6 * $container-height));
        }
      }
    }
  }

  .av-launcher-item {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    position: absolute;
    transition: transform 0.3s ease-out, bottom 0.3s ease-out;
    visibility: hidden;
    label {
      width: 0;
      opacity: 0;
      display: none;
      cursor: pointer;
      font-weight: bold;
      z-index: 100010;
      transition: all 0.3s ease-out;
      visibility: hidden;
      transform: scale(0);
      margin-right: 5px;
      color: var(--av-font-color-dark);
    }
    av-button {
      transform: scale(0.8);
      z-index: 100010;
      transition: transform 0.1s ease-out;
    }

    &:after {
      content: "";
      width: $container-width;
      height: $container-width;
      background-color: var(--av-color-gray);
      position: absolute;
      top: 0px;
      opacity: 0;
      border-radius: calc($container-width * 0.5);
      transform: scale(0.8);
      transition: all 0.3s ease-out;
    }
    &:hover {
      av-button {
        transform: scale(0.9);
      }
      label {
        opacity: 1;
      }
      &:after {
        // left: -10px;
        /* right: 0; */
        opacity: 1;
        width: calc(100% + 10px);
      }
    }

    & + av-button {
      z-index: 100020;
      border-radius: calc($container-width * 0.5);
      box-shadow: var(--av-box-shadow-container);
    }
  }

  .av-arrow {
    border-right: 2px solid var(--av-color-primary-contrast);
    border-bottom: 2px solid var(--av-color-primary-contrast);
    width: 20px;
    height: 20px;
  }

  .av-arrow-down {
    transform: rotate(45deg);
    margin-top: -10px;
  }

  .av-arrow-up {
    transform: rotate(225deg);
    margin-top: 10px;
  }
}

.av-launcher-left {
  .av-launcher-item {
    left: 0;
    padding-right: 20px;
    &:after {
      left: 0px;
    }
  }
}

.av-launcher-right {
  .av-launcher-item {
    padding-left: 20px;
    &:after {
      right: 0px;
    }
  }
}

.av-image-bkg {
  width: 60px;
  height: 60px;
  background-size: cover;
  border-radius: 30px;
}
